
import { useState, useEffect, } from "react";
import { useNavigate } from 'react-router-dom';
import { connect } from "react-redux";
import moment from "moment";

import CustomModal from "../../../common/CustomModal";
import { BiLoaderCircle } from "react-icons/bi";

import { DeleteAccount } from "../../../redux/v2/user/actions";
import { delay } from "../../../utils";
import { clearLocalStorage } from "../../../utils/localstorage"
import { callSocket } from "../../../utils/socket"


function DeleteAccountButton(props) {
    const navigate = useNavigate();

    const platform = localStorage.getItem("indi-platform");
    const isUsingApp = platform && (platform === "ios-app" || platform === "android-app");


    const [showModal, setShowModal] = useState(false);
    const [showModal2, setShowModal2] = useState(false);
    const [showModal3, setShowModal3] = useState(false);

    const [ongoingDelete, setOngoingDelete] = useState(false);
    const [isDeleteNow, setIsDeleteNow] = useState(false);

    const { account } = props.User;
    const billing = account?.billingInfo;

    const deleteAccount = async (now) => {

        setIsDeleteNow(now);

        setShowModal2(false);

        setOngoingDelete(true);

        const res = await props.DeleteAccount(now);

        if (res.success) {
            delay(() => {
                setOngoingDelete(false);
                setShowModal(false);
                setShowModal3(true);

                if (!isUsingApp) {
                    navigate("/login");
                    // window.location.href = "/login";
                } else {
                    callSocket(`logout-mobile`);
                }
                clearLocalStorage();

            }, 2000);
        }
    }

    return isUsingApp ? (
        <>
            <CustomModal
                id="delete-ad"
                show={showModal3}
                toggle={() => setShowModal3(!setShowModal3)}
                title="Account Deletion"
                body={
                    <>
                        {
                            isDeleteNow
                                ? `Your request to delete your account has been received. Your account will be permanently deleted.`
                                : `Your request to delete your account has been received. Your account will be permanently deleted on ${moment(new Date(billing?.currentPeriodEndsAt)).format('MMMM DD, YYYY')}`
                        }
                    </>
                }
                footerButtons={
                    [

                        {
                            label: "CLOSE",
                            action: () => {
                                setShowModal3(false)
                            },
                        }
                    ]
                }
            />

            <CustomModal
                id="delete-ad"
                show={showModal}
                toggle={() => setShowModal(!setShowModal)}
                title="Account Deletion"
                body={
                    <>
                        Please note, deleting your account data will result in the removal of your account and data. This includes the ability to access any content or videos. It may also result in the inability to re-create your account.
                    </>
                }
                footerButtons={
                    [

                        !ongoingDelete ? {
                            label: "DELETE ACCOUNT",
                            action: () => {
                                setShowModal2(true)
                            },
                        } : {
                            label: <>DELETING... <BiLoaderCircle className="btn-loading" style={{ marginLeft: "10px" }} /></>,
                            action: () => {
                            },
                        },
                    ]
                }
            />

            <CustomModal
                id="delete-adc"
                show={showModal2}
                toggle={() => setShowModal2(!setShowModal2)}
                title="Account Deletion Confirmation"
                body={
                    <>
                        This action cannot be undone. You have the option to delete your account immediately or at the end of your subscription period.
                    </>
                }
                footerButtons={
                    [
                        {
                            label: "Delete Immediately",
                            action: () => {
                                deleteAccount(true);
                            },
                        },
                        {
                            label: "After Subscription Ends",
                            action: () => {
                                deleteAccount(false);
                            },
                        },
                        {
                            label: "Cancel",
                            action: () => {
                                setShowModal2(false)
                            },
                        },
                    ]
                }
            />

            <div style={{ width: "100%", marginTop: "40px" }} className="flex-c">
                <button style={{
                    border: "none",
                    backgroundColor: "transparent",
                    fontWeight: 300,
                    color: "#000"
                }}
                    onClick={() => {
                        setShowModal(true)
                    }}
                >
                    Delete Account
                </button>
            </div>
        </>
    ) : "";
}

const mapStateToProps = (state) => ({
    User: state.User
});

export default connect(mapStateToProps, {
    DeleteAccount,
})(DeleteAccountButton);